import { ApiResponse, Types } from "../../types/types";
import avatarImg from "../../icons/avatar.png";
import { getAuthToken } from "../../utils/utils";
import { API_BASE, BASE_URL } from "../../config/api"; // <--- подключаем

// --- Получить список всех событий ---
export const fetchEvents = async (
  event_timing:
    | "all"
    | "current_or_planned"
    | "finished"
    | "canceled"
    | "overdue" = "current_or_planned",
  ownerId?: number
): Promise<Types[]> => {
  const token = getAuthToken();
  let allResults: Types[] = [];
  let nextUrl:
    | string
    | null = `${API_BASE}/events/?event_timing=${event_timing}&ordering=starts_at${
    ownerId ? `&owner__id=${ownerId}` : ""
  }`;

  try {
    while (nextUrl) {
      const response = await fetch(nextUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        },
        credentials: "include",
        cache: "no-store",
      });

      if (!response.ok) {
        throw new Error("Ошибка загрузки данных");
      }

      const data: ApiResponse = await response.json();
      allResults = [...allResults, ...data.results];
      nextUrl = data.next;
    }

    return allResults.map((item: any) => ({
      id: item.id,
      is_finished: item.is_finished,
      name: item.name,
      date_start: item.starts_at,
      date_end: item.ends_at,
      place: item.place?.name || "Неизвестно",
      place_city: item.place?.city || "Неизвестно",
      price: item.price_min ? `${item.price_min} ₽` : "Бесплатно",
      imageUrl: item.cover_medium
        ? item.cover_medium.startsWith("http")
          ? item.cover_medium
          : `${BASE_URL}${item.cover_medium}`
        : "https://via.placeholder.com/150",
      category: Array.isArray(item.categories_info)
        ? item.categories_info.map((c: any) => ({ name: c.name }))
        : [],
      countTicketTypes: item.ticket_types?.length || 0,
      visitors: {
        total: item.visitors?.total || 0,
        listed: item.visitors?.listed || 0,
        list:
          item.visitors?.list?.map((visitor: any) => ({
            id: visitor.id || 0,
            first_name: visitor.first_name,
            avatar_small: visitor.avatar_small || avatarImg,
          })) || [],
      },
    }));
  } catch (error) {
    console.error("Ошибка загрузки событий:", error);
    return [];
  }
};

// --- Получить событие по ID ---
export const getEventById = async (
  id: string | number
): Promise<Types | null> => {
  try {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE}/events/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      credentials: "include",
      cache: "no-store",
    });

    if (!response.ok) {
      throw new Error("Ошибка загрузки данных о событии");
    }

    const data = await response.json();

    return {
      id: data.id,
      is_finished: data.is_finished,
      name: data.name,
      date_start: data.starts_at,
      date_end: data.ends_at,
      place: data.place?.name || "Неизвестно",
      place_city: data.place?.city || "Город не указан",
      price: data.ticket_types_data?.[0]?.price
        ? `${data.ticket_types_data[0].price} ₽`
        : "Бесплатно",
      imageUrl: data.cover_medium
        ? data.cover_medium.startsWith("http")
          ? data.cover_medium
          : `${BASE_URL}${data.cover_medium}`
        : "https://via.placeholder.com/150",
      description: data.description,
      owner_info: {
        id: data.owner_info.id,
        first_name: data.owner_info.first_name,
        avatar_small: data.owner_info.avatar_small || avatarImg,
      },
      is_owner: data.is_owner,
      countTicketTypes: data.ticket_types?.length || 0,
      ticket_types_data: Array.isArray(data.ticket_types_data)
        ? data.ticket_types_data.map((ticket: any) => ({
            id: ticket.id,
            name: ticket.name,
            price: ticket.price,
            max_count: ticket.max_count,
            sorter: ticket.sorter,
          }))
        : [],
      promocodes_info: Array.isArray(data.promocodes_info)
        ? data.promocodes_info.map((promocode: any) => ({
            id: promocode.id,
            name: promocode.name,
            discount: promocode.discount,
            sorter: promocode.sorter,
          }))
        : [],
      photos_data: Array.isArray(data.photos_data)
        ? data.photos_data.map((photo: any) => ({
            id: photo.id,
            medium: photo.medium.startsWith("http")
              ? photo.medium
              : `${BASE_URL}${photo.medium}`,
            sorter: photo.sorter,
          }))
        : [],
      visitors: {
        total: data.visitors?.total || 0,
        listed: data.visitors?.listed || 0,
        list:
          data.visitors?.list?.map((visitor: any) => ({
            id: visitor.id || 0,
            first_name: visitor.first_name,
            avatar_small: visitor.avatar_small || avatarImg,
          })) || [],
      },
      category: Array.isArray(data.categories_info)
        ? data.categories_info.map((category: any) => ({
            name: category.name,
          }))
        : [],
    };
  } catch (error) {
    console.error(`Ошибка загрузки события с ID ${id}:`, error);
    return null;
  }
};
